/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// modules
	__webpack_require__(1);
	__webpack_require__(2);
	__webpack_require__(3);
	
	$('.js-countdown').each(function(){
	  new CountDown().init($(this));
	});
	
	$('.js-height').each(function(){
	  new EqHeight().init($(this));
	});
	
	$('.js-accordion-trigger').each(function(){
	  var $parent = $(this).closest('.js-accordion');
	  new Accordion().init($(this), $parent);
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	/**
	* カウントダウンのコンストラクタ
	* @constructor
	*/
	module.exports = CountDown = function(){};
	
	/**
	* initialize
	* @param {selector} el - jquery セレクタ
	*/
	CountDown.prototype.init = function(el){
	  this.element = $(el);
	  this.event();
	}
	
	/**
	* event
	*/
	CountDown.prototype.event = function(){
	  var self = this;
	
	  var START_DATE = new Date(2017, 7, 26, 0, 0, 0);
	
	  this.getServerDate().done(function(data, textStatus, xhr){
	    var res = new Date(xhr.getResponseHeader('Date'));
	    self.render(START_DATE, res);
	  }).fail(function(){
	    var res = new Date();
	    self.render(START_DATE, res);
	  });
	}
	
	CountDown.prototype.getServerDate = function(){
	  return $.ajax({
	    type : 'GET',
	    url : window.location.href
	  });
	};
	
	CountDown.prototype.render = function(start, today){
	  var diff = start - today;
	  var dayCount = this.getDiffTime(start - today);
	  var date = (dayCount === undefined) ? '?' : dayCount[0]; 
	  this.element.html(date);
	};
	
	CountDown.prototype.getDiffTime = function(x){
	  var y = 24 * 60 * 60 * 1000;
	  if(x >= 0){
	    var day = Math.floor(x / y);
	    var hour = Math.floor((x % y) / (60 * 60 * 1000));
	    var minute = Math.floor((x % y) / (60 * 1000)) % 60;
	    var second = Math.floor((x % y) / 1000) % 60 % 60;
	    var msecond = Math.floor((x % y) / 10 ) % 100;
	    var time = this.zeroPadding([day, hour, minute, second, msecond]);
	    return time;
	  }
	};
	
	CountDown.prototype.zeroPadding = function(array){
	  var num = [];
	  for(var i = 0; i < array.length; i++){
	    num.push(('0' + array[i]).substr(-2));
	  }
	  return num;
	};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	/**
	* 高さ揃えのコンストラクタ
	* @constructor
	*/
	module.exports = EqHeight = function(){};
	
	/**
	* initialize
	*/
	EqHeight.prototype.init = function(el){
	  this.element = $(el);
	  this.group = this.element.attr('data-eqHeight-cls');
	  this.groupArray = this.group.split(',');
	  this.resize();
	  this.event();
	};
	
	/**
	* event
	*/
	EqHeight.prototype.event = function(){
	  this.checkDevice();
	  if(this.device === 'sp'){
	    this.removeHeight(this.groupArray);
	  }else{
	    this.removeHeight(this.groupArray);
	    this.setHeight(this.groupArray);
	  }
	};
	
	/**
	* setHeight
	*/
	EqHeight.prototype.setHeight = function(arr){
	  for(var i = 0; i < arr.length; i++){
	    var $item = $('.' + arr[i]);
	    var h = [];
	    $item.each(function(){
	      h.push($(this).outerHeight());      
	    });
	    var max = Math.max.apply(null, h);
	    $item.each(function(){
	      $(this).css('min-height', max);  
	    });
	  }
	};
	
	/**
	* removeHeight
	*/
	EqHeight.prototype.removeHeight = function(arr){
	  for(var i = 0; i < arr.length; i++){
	    var $item = $('.' + arr[i]);
	    for(var i = 0; i < arr.length; i++){
	      var $item = $('.' + arr[i]);
	      $item.removeAttr('style');
	    }
	  }
	};
	
	/**
	* checkDevice
	*/
	EqHeight.prototype.checkDevice = function(){
	  var w = $(window).width();
	  var device = (w < 768) ? 'sp' : 'pc';
	  this.device = device;
	};
	
	/**
	* resize
	*/
	EqHeight.prototype.resize = function(){
	  var self = this;
	
	  var timer = false;
	  $(window).on('resize', function(){
	    if(timer !== false){
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function(){
	      self.event();
	    },200);
	  });
	};
	


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/**
	* アコーディオンのコンストラクタ
	* @constructor
	*/
	module.exports = Accordion = function(){};
	
	/**
	* initialize
	* @param {selector} el - jquery セレクタ
	* @param {selector} parent - jquery セレクタ
	*/
	Accordion.prototype.init = function(el, parent){
	  this.element = $(el);
	  this.parent = $(parent);
	  this.event();
	}
	
	/**
	* event
	*/
	Accordion.prototype.event = function(){
	  var self = this;
	
	  var active = 'is-active';
	
	  this.element.prop('checked', false).removeClass(active);
	
	  this.element.on('change', function(){
	    var isChecked = self.element.prop('checked');
	    if(isChecked){
	      self.parent.addClass(active);
	    }else{
	      self.parent.removeClass(active);
	    }
	  });
	}
	
	


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.js